import { getDepartmentListByCountryIdRequest } from "../../data/departmentApi";

function getPayloadData(response) {
  if (Array.isArray(response)) {
    return response;
  }

  if (Array.isArray(response?.data)) {
    return response.data;
  }

  if (Array.isArray(response?.data?.data)) {
    return response.data.data;
  }

  return [];
}

export async function getDepartmentListByCountryIdUseCase(countryId) {
  if (!countryId) {
    throw new Error("El id del pais es obligatorio.");
  }

  return getPayloadData(await getDepartmentListByCountryIdRequest(countryId));
}
